import React from 'react';
import { useGetAreaCodeText } from 'src/hooks/useGetAreaCodeText';

const AreaCodeDisplay = (props: any) => {
  const { uuid, containerClassName, ContainerComp } = props;
  const text = useGetAreaCodeText(uuid);
  const cProps = {
    className: containerClassName,
  };
  return ContainerComp ? (
    <ContainerComp {...cProps}>{text}</ContainerComp>
  ) : (
    <span {...cProps}>{text}</span>
  );
};
export default AreaCodeDisplay;
